const FeatureCard: React.FC<{ title: string; description: string; imageUrl?: string }>
  = ({ title, description, imageUrl }) => (
    <div className="rounded-2xl bg-white/90 p-5 shadow hover:shadow-md transition">
      {imageUrl ? (
        <img src={imageUrl} alt="" className="mb-3 h-10 w-10 object-contain" />
      ) : (
        <div className="mb-3 h-10 w-10 rounded-xl bg-gray-200" />
      )}
      <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
      <p className="mt-1 text-sm text-gray-600">{description}</p>
    </div>
  );

export default FeatureCard;